import { PlayerWithTeamAndEvent } from '@/feature/betslip-pickem/types';
import { createWithEqualityFn } from 'zustand/traditional';

export type PlayerProfileTabsStore = {
    selectedPlayerIndex: number;
    playersList: PlayerWithTeamAndEvent[];
    selectedSinglePlayer: PlayerWithTeamAndEvent | null;
    selectedPlayerProjectionFilter?: string;
    popularPlayerProjection?: string;
    actions: {
        setSelectedPlayerIndex: (tab: number) => void;
        setPlayersList: (listOfPlayers: PlayerWithTeamAndEvent[]) => void;
        setSelectedSinglePlayer: (player: PlayerWithTeamAndEvent | null) => void;
        setSelectedPlayerProjectionFilter: (filter?: string) => void;
        setPopularPlayerProjection: (projection?: string) => void;
    };
};

export const usePlayerProfileDataStore = createWithEqualityFn<PlayerProfileTabsStore>()(
    set => ({
        selectedPlayerIndex: 0,
        playersList: [],
        selectedPlayerProjectionFilter: undefined,
        selectedSinglePlayer: null,
        actions: {
            setSelectedPlayerIndex: tab => {
                set({ selectedPlayerIndex: tab });
            },
            setPlayersList: (listOfPlayers: PlayerWithTeamAndEvent[]) => {
                set(() => ({ playersList: [...listOfPlayers] }));
            },
            setSelectedSinglePlayer: (player: PlayerWithTeamAndEvent | null) => {
                set(() => ({ selectedSinglePlayer: player }));
            },
            setSelectedPlayerProjectionFilter: (filter?: string) => {
                set(() => ({ selectedPlayerProjectionFilter: filter }));
            },
            setPopularPlayerProjection: (projection?: string) => {
                set(() => ({ popularPlayerProjection: projection }));
            },
        },
    }),
    Object.is
);
